import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=9661f634&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
import style0 from "./Message.vue?vue&type=style&index=0&id=9661f634&prod&lang=scss"
import style1 from "./Message.vue?vue&type=style&index=1&id=9661f634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9661f634",
  null
  
)

export default component.exports